import cn from 'classnames';
import React from 'react';
import { Link } from '@/Framework/Router/Next/Link';
import URL from '@/finsight/Router/urlConstants';
import SearchField from '../../../common/SearchContainer/SearchContainer';
import Tabs from '@/finsight/ui/components/research/common/Tabs';
import Tooltip from '@dealroadshow/uikit/core/components/Tooltip';
import IconResearchDocument from '@dealroadshow/uikit/core/components/Icon/IconResearchDocument';
import { ProductAbbreviations } from '@/finsight/domain/Product';
import { RegionAbbreviations } from '@/finsight/domain/Region';
import LogInButton from '@/finsight/ui/common/components/LogInButton';
import { UserPlanType } from '@/users/domain/UserPlan';
import CheckUserPlanAccess from '@/finsight/ui/common/components/CheckUserPlanAccess';

import tabsStyles from '@dealroadshow/uikit/core/styles/tabs.scss';
import cardStyles from '@dealroadshow/uikit/core/styles/card.scss';
import styles from './researchTableWrapper.scss';

interface IProps {
  children: React.ReactNode,
}

const ResearchTableWrapper = ({ children }: IProps) => {
  const renderContent = () => (
    <>
      <div
        className={ cn(
          cardStyles.cardInnerHorizontal,
          styles.cardHeader,
          styles.withTitle,
        ) }
      >
        <div className={ styles.title } data-test="researchTileTitle">Research</div>
        <div className={ styles.actions }>
          <span className={ styles.actionsIconContainer }>
            <Tooltip content="Go to US ABS Research">
              <Link
                to={ `${ URL.NRSRO_RESEARCH }?products=${ ProductAbbreviations.ABS }&regions=${ RegionAbbreviations.USOA }` }
                // @ts-ignore
                target="_blank"
              >
                <IconResearchDocument
                  className={ styles.actionsIcon }
                />
              </Link>
            </Tooltip>
          </span>
          <SearchField />
        </div>
      </div>
      <div className={ cn(tabsStyles.tableTabs, cardStyles.cardInnerHorizontal, styles.tableTabs) }>
        <Tabs dataTest="researchTableTabs" isTile className={ styles.tab } />
      </div>
      <div className={ cn(tabsStyles.tabsFooter, styles.tabsFooter) } />
      { children }
    </>
  );

  const unauthorizedFallback = (
    <div
      className={ cn(
        cardStyles.cardInnerHorizontal,
        styles.cardHeaderUnlogged,
      ) }
    >
      <h3 data-test="researchTileTitle">Research</h3>
      <LogInButton
        dataTest="researchTileTitleLoginButton"
        withIcon={ false }
        className={ styles.loginButton }
        variant="outline"
      />
    </div>
  );

  return (
    <div className={ styles.cardContainer }>
      <CheckUserPlanAccess
        requiredUserPlan={ UserPlanType.STARTER }
        fallback={ unauthorizedFallback }
      >
        { renderContent() }
      </CheckUserPlanAccess>
    </div>
  );
};

export default ResearchTableWrapper;
